import { Col, Form, Row, Select } from "antd";
import { ITinyBarChart } from "../../../interfaces/dashboard";
import MultiSelectTag from "../../../components/multi-select-tag";
import { listStatusSir } from "../../../utils/helper";
import TinyBarChart from "../../../components/chart/tiny-bar-chart";

const VIEWS_BY= [
  {
    value: "volume",
    label: "Volume"
  },
  {
    value: "value",
    label: "Value"
  }
]

interface YtdTopSupplierChartProps {
  initialValues: any;
  onChangeFilter: (value: any) => void;
  dataChart: ITinyBarChart[];
  loading?: boolean
}

const YtdTopSupplierChart: React.FC<YtdTopSupplierChartProps> = ({ onChangeFilter, initialValues, dataChart = [], loading = false }) => {
  const [form] = Form.useForm();

  const handleFilter = (values: any) => {
    onChangeFilter(values);
  };

  return (
    <Form form={form} initialValues={initialValues} layout="horizontal" onValuesChange={handleFilter}>
      <Row gutter={24}>
        <Col span={10}>
          <Form.Item label="View by" name="viewBy" style={{marginBottom: 5}}>
            <Select
              options={VIEWS_BY}
              placeholder="View by"
            />
          </Form.Item>
        </Col>
        <Col span={14}>
          <Form.Item label="Filter by Status" name="statuses" style={{marginBottom: 5}}>
            <MultiSelectTag
              allowClear
              showSearch
              maxTagCount={"responsive"}
              placeholder="All"
              options={listStatusSir.map((item: string) => ({
                value: item.toString(),
                label: item,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <TinyBarChart data={dataChart} color="#7ED4FF" height={410} loading={loading} />
    </Form>
  );
};

export default YtdTopSupplierChart;
